import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchaseApprovalModel } from "../purchaseApprovalModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchaseApprovalDetailsModel } from "./details/purchaseApprovalDetailsModel"
import { formatNum } from "@/utils/utils";
import { PurchaseTable } from "./PrintPurchaseTable";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import useGlobalModel from "@/model/globalModel";
import { purchaseApprovalService } from "../purchaseApprovalService";
export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, descRows, exportPurchaseApproval, setPrint, logVisible, setLogVisible, loadData } = usePurchaseApprovalModel();
    const { setDetailEditForm, setDetailDataSource, setDetailAddList, setDetailAddForm, resetAddCatch } = usePurchaseApprovalDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [printVisible, setPrintVisible] = useState<boolean>(false);
    const { user: { roles, username }, shopAndOrg: { shopId, shopCode, shopName, shopType } } = useGlobalModel();

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        // if (roles.includes('hd-c' || 'hd-g') && selectedRow.status !== 'purchase_approval.init') {
        //     globalPrompt("message", { text: "采购,站点库房管理员，此条审批单状态不为'草拟'，您只可查看，不可编辑哦！", type: "warning" });
        //     return;
        // }
        // if (roles.includes('hd-e') && selectedRow.status == 'purchase_approval.init') {
        //     globalPrompt("message", { text: "库房管理员，此条审批单状态为'草拟',您只可查看，不可编辑哦！", type: "warning" });
        //     return;
        // }
        if (selectedRow.status == 'purchase_approval.init' && username !== selectedRow.createUser) {
            globalPrompt("message", { text: "此条审批单状态为'草拟',只允许创建人编辑哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-5-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.id as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "采购审批单跳转详情",
                type: "warning",
                text: "您还有采购审批单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.id as string, mode: "edit" });
                    // updateEditFormVal(null);
                    setDetailEditForm({})
                    setDetailDataSource([])
                }
            })
        }
    }
    const desc: IDescription[] = [
        {
            label: "计划总量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "计划总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        }
    ]
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-5-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.id as string, mode: "look", },
            true
        );

    }
    const onLookLog = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setLogVisible(true);

    }
    const onPrint = () => {
        if (selectedRowKeys.length === 0) {
            globalPrompt("message", { text: "请选择数据进行打印！", type: "warning" });
            return;
        }
        setPrintVisible(true);
    }
    const onTrunPlan = () => {

        if (!selectedRowKeys.length) {
            globalPrompt("message", { text: "请选择数据进行转订单！", type: "warning" });
            return;
        }
        let noList = descRows.find((item: any) => item.status !== 'purchase_approval.audited')
        if (noList) {
            globalPrompt("message", { text: "请选择已审核状态审批单！", type: "warning" });
            return;
        }
        globalPrompt("modal", {
            title: "采购审批转采购订单",
            type: "success",
            text: "",
            okText: "确定",
            onOk: () => {
                let list = descRows.map((item: any) => item.code)
                purchaseApprovalService.tranPlan(list).then(res => {
                    if (res.retCode == '200') {
                        loadData()
                        globalPrompt("message", { text: res.retData, type: "success" });

                    }
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onRemainingApproval = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行剩余审批，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }

        if (selectedRow.status !== 'purchase_approval.transfer') {
            globalPrompt("message", { text: "只有已转接状态的审批单才能进行剩余审批！", type: "warning" });
            return;
        }
        let { retData }: any = await purchaseApprovalService.one(selectedRowKeys[0]);
        let list = retData.details.filter((item: any) => !item.planCode && item.deleteFlag !== 1)
        if (list.length < 1) {
            globalPrompt("message", { text: "本工单商品已全部转订单！", type: "warning" });
            return;
        }
        let formVal = {};
        if (retData) {
            const { details, ...from } = retData
            let fileList: any = []
            const { md5, fileName } = from
            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            formVal = {
                createUser: username,
                orgCode: from.orgCode,
                shopId: from.shopId,
                shopName: from.shopName,
                contact: from.contact,
                phone: from.phone,
                approveTypeCode: from.approveTypeCode,
                approveTypeName: from.approveTypeName,
                purchaseTypeCode: from.purchaseTypeCode,
                purchaseTypeName: from.purchaseTypeName,
                note: from.note,
                orgName: from.orgName,
                sourceApp: from.sourceApp,
                branch: from.branch,
                oldCode: selectedRow.code,
                fileList,
                details
            }
        }
        let supplierEditKey = "11-5-1";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, {
                id: '',
                mode: "add",
                parentInfo: {
                    remainingApprovalData: { ...formVal }
                }
            });
        } else {
            globalPrompt("modal", {
                title: "采购订单跳转新增",
                type: "warning",
                text: "您还有采购订单新增未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, {
                        id: '',
                        mode: "add",
                        parentInfo: {
                            remainingApprovalData: { ...formVal }
                        }
                    });
                    resetAddCatch('add')
                }
            })
        }
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_ADD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                disabled={shopType !== 1}
                onClick={() => {
                    let supplierEditKey = "11-5-1";
                    let isFindNav = findNav(supplierEditKey);
                    if (!isFindNav) {
                        addNav(supplierEditKey, {
                            id: '',
                            mode: "add",
                            parentInfo: {}
                        });
                    } else {
                        globalPrompt("modal", {
                            title: "采购订单跳转新增",
                            type: "warning",
                            text: "您还有采购订单新增未保存，是否跳转",
                            okText: "跳转未保存页",
                            onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                            cancelText: "打开新页签",
                            onCancel: () => {
                                switchNavState(supplierEditKey, {
                                    id: '',
                                    mode: "add",
                                    parentInfo: {}
                                });
                                resetAddCatch('add')
                            }
                        })
                    }
                }}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_EDIT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_LOOK}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_LOOKLOG}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onLookLog()}
            >流转记录</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_EXPORT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { exportPurchaseApproval().then() }}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_PRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint()}
            >打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_TRANSFER}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onTrunPlan}
            >转订单</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_RESIDUALAPPROVAL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onRemainingApproval}
            >剩余审批</Button>
        </YhAuth>
    </>;

    return (
        <>
            {/* <YhBox title={"采购订单列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}> */}
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <PurchaseTable printVisible={printVisible} setPrintVisible={setPrintVisible} />
        </>
    )
}